import React, { useState } from 'react';
import { Heart, MessageCircle } from 'lucide-react';
import { Avatar, Verified } from './shared';
import { moments } from '../mock';

function MomentCard({ m }) {
  const [liked, setLiked] = useState(false);
  return (
    <article className="px-4 py-4 animate-fade-up">
      <div className="flex items-center gap-2.5 mb-3">
        <Avatar src={m.avatar} size={38} />
        <span className="text-sm font-semibold text-white">{m.user}</span>
        {m.verified && (
          <span className="flex items-center gap-1 text-[12px] text-[#22c55e]">
            <Verified size={13} /> Verified
          </span>
        )}
      </div>
      <p className="text-[15px] text-white mb-3 leading-snug">{m.caption}</p>
      <div className="rounded-2xl overflow-hidden ring-1 ring-[#141c28]">
        <img src={m.image} alt="" className="w-full aspect-[16/10] object-cover" />
      </div>
      <div className="flex items-center gap-5 mt-3">
        <button onClick={() => setLiked((v) => !v)} className="flex items-center gap-1.5 text-sm text-[#8b95a5]">
          <Heart size={20} className={liked ? 'fill-[#f43f5e] text-[#f43f5e]' : 'text-[#8b95a5]'} />
          <span>{liked ? 'Liked' : 'Like'}</span>
        </button>
        <button className="flex items-center gap-1.5 text-sm text-[#8b95a5]">
          <MessageCircle size={20} /> <span>Reply</span>
        </button>
      </div>
      <div className="h-px bg-[#141c28] mt-4 -mb-4" />
    </article>
  );
}

export default function Moments() {
  return (
    <div>
      {moments.map((m) => (
        <MomentCard key={m.id} m={m} />
      ))}
      <p className="text-center text-[12px] text-[#5c6675] py-6">You're all caught up</p>
    </div>
  );
}
